import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

export default function PetAIServiceAgreement() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="agreement-page"
      style={{ padding: "16px 12px", maxWidth: "960px", margin: "0 auto" }}
    >
      <h1>伴知宠育宠大模型服务协议</h1>

      <p>更新日期：2026年 3月 30日</p>
      <p>生效日期：2026年 3月 30日</p>

      <p>
        欢迎使用由知宠派智能科技（杭州）有限公司提供的伴知宠育宠大模型服务（以下简称“大模型”或“本服务”）。
        <strong>
          在您接受本服务条款或使用伴知宠育宠大模型之前，请仔细阅读并充分理解以下全部内容（其中限制或免除责任条款，以及其他涉及您重大权益的条款将会以加粗等形式提示您重点注意）
        </strong>
      </p>
      <p>
        如您对本服务条款有疑问的，请通过本服务条款“联系我们”进行询问，知宠派智能科技（杭州）有限公司将向您解释条款内容。如您不接受本服务条款，或者无法准确理解知宠派智能科技（杭州）有限公司对条款内容的解释，请不要使用伴知宠育宠大模型。
      </p>

      <h2>1、服务内容及服务条款的确认</h2>
      <p>
        1.1
        伴知宠育宠大模型以通义千问大模型作为基础模型，并在育宠领域进行了优化，目前在伴知宠APP内以“宠参谋”功能的形式提供服务，用户可以使用该功能进行育宠知识的问答对话。
      </p>
      <p>
        1.2
        适用人群：主要服务于有育宠需求的用户，包括有宠物的用户群体，或者有咨询育宠需求的用户。借助人工智能的技术特点，为这类群体提供更全面、快捷的知识问答，重点解决这类群体在育宠上的问题，作为其育宠过程中的辅助参考。本服务不向未成年人提供服务。
      </p>
      <p>
        1.3
        适用场景：伴知宠育宠大模型依托伴知宠APP提供服务，主要服务于育宠群体的用户咨询和知识解答。用户可将需要询问的育宠问题发送给大模型，大模型给出相应的回答。
      </p>
      <p>
        1.4
        服务范围：限定特定领域，主要针对育宠场景，面向有育宠类需求的用户，基于用户的文本输入，对文本进行自然语言文本处理，识别用户查询意图，结合伴知宠自有育宠知识库，帮助用户快速解答育宠领域内的各类问题。
      </p>
      <p>
        1.4.1
        用户询问育宠类问题，大模型对用户输入的问题进行识别，如存在和伴知宠自有育宠知识库相匹配的内容，则大模型以知识库内容为参考进行输出，如未匹配上知识库的内容，则由大模型直接进行输出。
      </p>
      <p>
        1.4.2
        用户询问非育宠类问题，超出本服务限定的特定领域，可能无法输出结果。
      </p>
      <p>
        1.5
        本服务条款内容包括条款正文、本服务条款明确援引的其他协议、知宠派智能科技（杭州）有限公司已经发布的或将来可能发布的单项服务条款/说明/公告/标准（如有，以下统称为“服务规则”），以及您确认同意的订购页面所包含的协议及条款。所有内容为本服务条款不可分割的组成部分，与本服务条款具有同等效力。
      </p>
      <p>
        1.6
        如您选择以页面确认或其他任何方式明示或默示表示接受本服务条款，或您注册了伴知宠APP并开始使用”宠参谋“功能，即表示您与知宠派智能科技（杭州）有限公司已达成协议，自愿接受本服务条款的全部内容，您使用伴知宠育宠大模型服务的行为都应当受本服务条款约束。除另有明确约定外，如您与知宠派智能科技（杭州）有限公司另行签署电子签名合同或纸质盖章合同的，相关文本与本服务条款有不一致之处，以双方另行签署的电子签名或纸质盖章文本为准。
      </p>
      <p>
        1.7本服务条款如由于业务发展或其他原因需要进行修订的，知宠派智能科技（杭州）有限公司将在伴知宠APP公布修订版本，您可前往查阅最新版条款内容。在知宠派智能科技（杭州）有限公司修改上述条款后，如果您不接受修改后的条款，您可以选择终止使用伴知宠育宠大模型服务。您继续使用的行为将被视为已接受了修改后的条款。
      </p>

      <h2>2、账号注册及使用规则</h2>
      <p>
        2.1
        您可浏览伴知宠APP关于AI育宠助手“宠参谋”或伴知宠育宠大模型的介绍，如您希望使用，您需先登录您的账号，或注册知宠派智能科技（杭州）有限公司认可的账号并登录。您注册登录的账号是知宠派智能科技（杭州）有限公司确认您身份的唯一依据。账号注册资料包括但不限于您的账号名称、头像、手机号码以及其他注册或更新应用产品时输入的所有信息。
      </p>
      <p>
        2.2
        您在注册账号时承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在账号注册资料中出现不实、违法和不良信息。且您保证在注册和使用账号时，不得有以下情形：
      </p>
      <p>2.2.1 违反宪法或法律法规规定的；</p>
      <p>2.2.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
      <p>2.2.3 损害国家荣誉和利益的，损害公共利益的；</p>
      <p>
        2.2.4
        歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
      </p>
      <p>2.2.5 宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；</p>
      <p>2.2.6 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
      <p>2.2.7 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p>2.2.8 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p>2.2.9 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
      <p>2.2.10 侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p>2.2.11 含有法律、行政法规禁止的其他内容的。</p>
      <p>2.3 注册完成后，请您妥善保存有关账号和密码，并对该账号进行的所有活动和行为负责。</p>
      <p>
        <strong>
          如因您自身原因（包括但不限于转让账号、与他人共用、自己泄露等）或您所用计算机或其他终端产品感染病毒或木马，而导致账号密码泄漏、遗失或其他损失后果将由您自行承担
        </strong>
        。
      </p>
      <p>
        2.4
        知宠派智能科技（杭州）有限公司有权对您提供的账号注册资料进行审查，若发现或者收到举报涉及注册资料存在不准确、不真实或含有违法、不良信息，知宠派智能科技（杭州）有限公司有权不予注册，并保留终止您使用伴知宠APP的权利。若您以虚假信息骗取账号注册或账号注册资料存在侵权、违法和不良信息的，知宠派智能科技（杭州）有限公司有权采取通知限期改正、暂停使用、注销登记等措施。对于冒用其他机构或他人名义注册账号名称的，知宠派智能科技（杭州）有限公司有权注销该账号，并向政府主管部门进行报告。
      </p>
      <p>
        2.5
        您若发现自身账号或密码被他人非法使用或有登录、使用异常情况的，应及时通知知宠派智能科技（杭州）有限公司，知宠派智能科技（杭州）有限公司将按照本服务条款或法律规定进行处理。
      </p>
      <p>
        2.6
        <strong>
          在法律法规允许的范围内，您同意您在注册、使用伴知宠APP的过程中相关的服务数据和记录，包括但不限于所有注册、登录、消费记录、客户服务记录和相关的使用统计数据，归知宠派智能科技（杭州）有限公司所有。发生争议时，您同意以知宠派智能科技（杭州）有限公司的系统数据为准，知宠派智能科技（杭州）有限公司保证该数据的真实性
        </strong>
        。
      </p>
      <p>
        2.7
        知宠派智能科技（杭州）有限公司发现账号使用者并非账号初始注册人时，有权暂停向您提供本服务的部分或全部服务，并有权采取进一步措施。
        <strong>
          您不应将账号或密码转让、出借、销售或以任何脱离您控制的形式交由他人使用，您对使用您的账号发生的所有活动负责，且转让、出借账号导致的任何后果均由您本人承担
        </strong>
        。
      </p>

      <h2>3、服务的开通</h2>
      <p>
        3.1
        您可根据自身需求，自行通过伴知宠APP注册账号，即可在宠参谋AI育宠助手功能中使用伴知宠育宠大模型服务，您在使用该服务前需仔细阅读本服务对应的服务规则。
      </p>

      <h2>4、服务使用规则</h2>
      <p>
        4.1您有权选择并获得知宠派智能科技（杭州）有限公司提供的伴知宠育宠大模型服务。
        <strong>
          除非另有证明，知宠派智能科技（杭州）有限公司储存在其服务器上的数据是您使用伴知宠育宠大模型服务的唯一有效证据
        </strong>
        。
      </p>
      <p>
        4.2
        您应当按照本协议的相关要求使用伴知宠育宠大模型服务。在使用过程中，对于您违反本协议的相关要求所引起的后果将由您自行承担，知宠派智能科技（杭州）有限公司不承担任何责任。
      </p>
      <p>
        4.3
        基于您对本服务的使用，知宠派智能科技（杭州）有限公司许可您一项个人的、基于法定或约定事由可撤销的、不可转让的、非独占的使用本服务进行内容输入并获得内容输出的权利。本协议未明示授权的其他一切权利仍由知宠派智能科技（杭州）有限公司保留，您在行使该些权利前须另行获得知宠派智能科技（杭州）有限公司的书面许可，知宠派智能科技（杭州）有限公司如未行使前述权利，并不视为对该权利的放弃。
        <strong>
          如果您使用、对外发布或传播本服务生成的输出，您应当：（1）主动核查输出内容的真实性、准确性，避免使用错误信息做出决策或者传播虚假信息；（2）以显著方式标明该输出内容系由人工智能生成，以向公众提示内容合成的情况；（3）不对生成的输出进行修改、编辑或以其他方式进行二次创作，避免引发侵权；（4）避免发布和传播任何违反本协议使用规范的输出内容
        </strong>
        。
      </p>
      <p>
        4.4
        <strong>
          为履行法定合规要求，知宠派智能科技（杭州）有限公司有权采取技术手段或人工手段对您使用本服务的行为及信息进行审查，包括但不限于对输入和输出进行审查、建立风险过滤机制、建立违法内容特征库等
        </strong>
        。如果发现您使用本服务不符合国家法律法规、政策规定，或可能侵犯他人合法权益或含有对其他第三方的广告信息等内容，或其他认为不符合要求的情况，知宠派智能科技（杭州）有限公司有权不向您提供服务；已提供服务的，知宠派智能科技（杭州）有限公司有权立即停止继续向您提供服务，并保存有关记录向相关主管部门报告。但是，该项约定不视为知宠派智能科技（杭州）有限公司对您使用本服务的合法性进行担保，您应自行对使用伴知宠育宠大模型服务所输出的内容承担责任。
      </p>
      <p>
        <strong>
          4.5
          作为伴知宠育宠大模型服务的使用者，您在使用上述服务时，应遵守相关法律法规政策及服务规则，维护互联网秩序和安全，同时，您不得利用伴知宠育宠大模型服务，实施任何违反国家法律法规政策的行为，也不得为任何违反法律法规政策的行为提供便利，包括但不限于：
        </strong>
      </p>
      <p><strong>4.5.1 违反宪法或法律法规政策规定的；</strong></p>
      <p><strong>4.5.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</strong></p>
      <p><strong>4.5.3 损害国家荣誉和利益的，损害公共利益的；</strong></p>
      <p>
        <strong>
          4.5.4 歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
        </strong>
      </p>
      <p><strong>4.5.5 宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；</strong></p>
      <p><strong>4.5.6 煽动民族仇恨、民族歧视，破坏民族团结的；</strong></p>
      <p><strong>4.5.7 破坏国家宗教政策，宣扬邪教和封建迷信的；</strong></p>
      <p><strong>4.5.8 散布谣言，扰乱社会秩序，破坏社会稳定的；</strong></p>
      <p><strong>4.5.9 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</strong></p>
      <p><strong>4.5.10 侮辱或者诽谤他人，侵害他人合法权益的；</strong></p>
      <p><strong>4.5.11 以非法民间组织名义活动的；</strong></p>
      <p>
        <strong>
          4.5.12 可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等损害未成年人身心健康的；
        </strong>
      </p>
      <p><strong>4.5.13 含有法律、行政法规禁止或其他违反社会公序良俗的内容的。</strong></p>
      <p>
        <strong>
          4.6 您不得通过输入，诱导生成不友善对话的输出，包括但不限于：
        </strong>
      </p>
      <p><strong>4.6.1 人身攻击及辱骂、威胁等侵害第三人合法权利的；</strong></p>
      <p><strong>4.6.2 故意发表诋毁竞争对手言论；</strong></p>
      <p><strong>4.6.3 发表具有诱导性、偏见性等不正确言论等。</strong></p>
      <p>
        <strong>
          4.7 您不得通过输入，恶意对抗本服务的过滤机制，包括但不限于：
        </strong>
      </p>
      <p><strong>4.7.1 输入难以辨识涵义或者故意提供空格、数字等字符故意躲避技术审核的；</strong></p>
      <p>
        <strong>
          4.7.2 恶意对抗行为，包括但不限于使用变体、谐音等方式规避服务检测来输入违反上述4.5和4.6的言论。
        </strong>
      </p>
      <p>
        <strong>
          4.8 干扰本服务正常运行以及损害知宠派智能科技（杭州）有限公司合法权益，包括但不限于：
        </strong>
      </p>
      <p><strong>4.8.1 利用本服务从事窃取商业秘密、窃取个人信息等违法犯罪活动；</strong></p>
      <p>
        <strong>
          4.8.2 未经知宠派智能科技（杭州）有限公司同意或未有合法正当依据，擅自去除、篡改本服务涉及的人工智能生成标识或深度合成内容显著标识；
        </strong>
      </p>
      <p>
        <strong>
          4.8.3 以导致知宠派智能科技（杭州）有限公司的计算机系统或设施承受不合理负载的方式获取输出，或进行可能导致此类情况出现的行为。
        </strong>
      </p>
      <p>
        <strong>
          4.9
          您不得利用亲宝宝育儿大模型服务进行侵害知宠派智能科技（杭州）有限公司或他人的知识产权或者合法利益的行为，包括但不限于：
        </strong>
      </p>
      <p>
        <strong>
          4.9.1 您不得修改、翻译、出版、改编、出租、转许可、在信息网络上传播或转让伴知宠育宠大模型服务或软件，也不得逆向工程、反编译或以其他方式发现伴知宠育宠大模型的任何源代码；
        </strong>
      </p>
      <p>
        <strong>
          4.9.2 您不得进行任何改变或试图改变伴知宠育宠大模型服务提供的系统配置或破坏知宠派智能科技（杭州）有限公司系统安全的行为；
        </strong>
      </p>
      <p>
        <strong>
          4.9.3 未经知宠派智能科技（杭州）有限公司的另行授权，您不得向任何第三方以任何形式提供本服务条款项下服务，包括但不限于转售、转租或转赠伴知宠育宠大模型服务；
        </strong>
      </p>
      <p>
        <strong>
          4.9.4 您不应进行其他超出知宠派智能科技（杭州）有限公司提供的服务范围，可能给知宠派智能科技（杭州）有限公司带来任何不利影响的行为或者是国家禁止的行为；
        </strong>
      </p>
      <p>
        <strong>
          4.9.5 您不得故意避开或者破坏著作权人为保护伴知宠育宠大模型相关软件、代码著作权而采取的技术措施,或实施侵害他人知识产权等任何合法权益的行为，比如私服、外挂等；
        </strong>
      </p>
      <p>
        <strong>
          4.9.6 您不得进行任何破坏或试图破坏网络安全的行为,包括但不限于通过钓鱼、病毒、木马、恶意代码等方式，对网站进行恶意扫描、非法侵入系统、非法获取数据等。
        </strong>
      </p>
      <p>
        <strong>
          4.10 您不得通过伴知宠育宠大模型进行经营性活动，否则知宠派智能科技（杭州）有限公司有权有权中止或终止向您提供服务而无需承担任何责任。
        </strong>
      </p>
      <p>
        <strong>
          4.11 如您通过伴知宠育宠大模型进行非经营性活动需要获得国家有关部门许可或批准的，应当获得有关的许可或批准。如您未办理必要审批而开展此类业务的，知宠派智能科技（杭州）有限公司有权中止或终止向您提供服务而无需承担任何责任。
        </strong>
      </p>

      <h2>5、知识产权与其他权益</h2>
      <p>
        <strong>
          5.1
          伴知宠育宠大模型相关的著作权、商标权、专利权等知识产权，以及与伴知宠育宠大模型相关的所有信息内容，包括但不限于文字、图片、档案、资讯、资料、网站架构、页面设计均由知宠派智能科技（杭州）有限公司依法享有知识产权或其他权益。知宠派智能科技（杭州）有限公司提供伴知宠育宠大模型服务时所涉及到的内容包括但不限于：产品、技术、程序、资料、文档、界面设计、数据资料、帐号等，其知识产权均归属于知宠派智能科技（杭州）有限公司。未经知宠派智能科技（杭州）有限公司书面同意，您不能为任何营利或非营利性的目的擅自复制、剽窃、传播、仿造这些内容、或创造与内容有关的派生产品、或以转让、出租、抵押、处置、许可的方式授权第三方实施、利用和转让上述知识产权。
        </strong>
      </p>
      <p>
        <strong>
          5.2
          您确认并同意，知宠派智能科技（杭州）有限公司作为本服务的开发、运营主体，本服务项下运营数据、用户数据以及经伴知宠育宠大模型服务处理后产生的所有数据等权利，均归属知宠派智能科技（杭州）有限公司所有，除非相关权利人依照法律规定应享有权利的除外。
        </strong>
      </p>
      <p>
        <strong>
          5.3
          您在使用伴知宠育宠大模型服务时，应当确保您提供的内容及您的使用行为已获得合法权利人的授权，不侵犯任何第三方的合法权益，所提供内容不涉及任何国家秘密、商业秘密、重要数据或其他可能会对国家安全或者公共利益造成不利影响的数据。如有第三方就您所提供、上传或使用的信息、数据或就您使用我们服务的行为及成果向知宠派智能科技（杭州）有限公司提起任何投诉、索赔、诉讼或其他类型的诉求，您应赔偿知宠派智能科技（杭州）有限公司因此遭受的全部损失（包括但不限于经济损失、商誉损失、维权支出、罚金/赔偿金、律师费、预期可得利益等损失）。
        </strong>
      </p>
      <p>
        <strong>
          5.4
          您理解并同意，为实现本服务目的，知宠派智能科技（杭州）有限公司将在法律允许的范围内对您上传、发布的内容进行存储及使用（包括但不限于复制、编辑、传送、展示等），并利用这些信息向您输出服务内容，以实现人机交互服务。请注意，根据具体应用场景，您在使用服务的过程中，所输入的内容可能会包含个人信息。如您不希望我们收集和处理前述个人信息的，请您谨慎输入前述信息，但因此可能会影响您正常使用时的部分或全部功能。
        </strong>
      </p>
      <p>
        <strong>
          5.5 知宠派智能科技（杭州）有限公司有权对您输入/发布的内容进行审核，但该审核不代表对用户发表的任何内容承担任何明示或默示的保证，也不代表知宠派智能科技（杭州）有限公司观点或意见。
        </strong>
      </p>
      <p>
        <strong>
          5.6
          您理解并知悉，在经过去标识化且无法重新识别特定个人的前提下，您提交的素材、会话内容等可能会被用于伴知宠育宠大模型训练，您特此赋予我们全球范围、可再许可、永久有效、免费的许可权，并允许我们用于如下场景：1）进一步优化模型和服务;2）市场营销和推广活动；3）学术研究。关于个人信息保护内容详见本协议第6条。
        </strong>
      </p>

      <h2>6、个人信息保护</h2>
      <p>
        6.1
        知宠派智能科技（杭州）有限公司非常重视对用户个人信息的保护。为确保您的隐私和个人信息安全，我们不建议您在使用本服务的过程中输入任何个人信息，确需输入个人信息时，请您确保该等信息合法、准确、真实，若您输入的个人信息涉及第三方的，请确保已获得第三方的同意。
      </p>
      <p>
        6.2 我们将按照
        <Link to="/privacy-policy" className="agreement-link">
          《伴知宠隐私政策》
        </Link>
        的规定收集、存储、使用、存储和保护您的个人信息，请您完整阅读上述隐私政策，以帮助您更好地保护您的个人信息。
      </p>

      <h2>7、免责声明</h2>
      <p>
        7.1
        您明确理解并同意，知宠派智能科技（杭州）有限公司是中立技术提供方，我们会以合理的技术和谨慎的态度提供亲伴知宠育宠大模型服务，但
        <strong>
          基于现阶段技术的局限性和人工智能技术的特殊性，我们无法保证模型生成内容的完整性和准确性，所生成内容也不代表我们的观点，您应慎重辨别模型生成内容的合法性、准确性、真实性、实用性和安全性（包括下载第三方网页中内容是否会感染电脑病毒），并采取谨慎的预防措施
        </strong>
        。我们将不断完善技术和功能，以期改进我们的服务，您可以通过本服务条款的“联系我们”提出意见或建议，我们将与您一起解决相应问题。
      </p>
      <p>
        7.2
        由于可能存在的计算机病毒、网络通讯故障、系统维护等方面的因素以及可能发生的不可抗力事件或意外事件，知宠派智能科技（杭州）有限公司在此明确声明不对本服务的可适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途或满足用户的需求、使用效果等作明示或暗示的保证。
      </p>

      <h2>8、违约处理</h2>
      <p>
        <strong>
          8.1
          若您的行为违反了国家法律法规的规定、本服务条款的约定，由此产生的责任和风险均由您承担，同时知宠派智能科技（杭州）有限公司有权采取包括但不限于暂停或终止伴知宠APP内的部分或全部服务，限制、中止或终止用户账号的登录和使用、追究法律责任等措施，也无需向用户退还支付的任何费用（如有）。如您的行为导致任何第三方损害的，您应当独立承担责任。如您的行为给知宠派智能科技（杭州）有限公司造成损害的，还应当赔偿知宠派智能科技（杭州）有限公司的所有损失（包括但不限于经济损失、商誉损失、维权支出、罚金/赔偿金、律师费、预期可得利益等损失）
        </strong>
        。
      </p>

      <h2>9、适用的法律</h2>
      <p>
        <strong>9.1 本服务条款适用中华人民共和国的法律，并且排除一切冲突法规定的适用。</strong>
      </p>
      <p>
        <strong>
          9.2
          如出现因本服务条款引起的或与本服务条款有关的任何纠纷的，您与知宠派智能科技（杭州）有限公司应友好协商解决，若协商不成，您同意将纠纷提交至杭州市余杭区有管辖权的人民法院。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。
        </strong>
      </p>

      <h2>10、联系我们</h2>
      <p>
        10.1
        知宠派智能科技（杭州）有限公司致力于为用户提供更优质的服务。如您认为本服务存在侵害您知识产权、商业秘密等合法权益的，您可通过以下方式进行投诉：
      </p>
      <p>（1）邮箱：support@zhichongpai.com。</p>
      <p>（2）邮寄信函，浙江省浙江省杭州市余杭区亲橙parkD6-403-3知宠派法务部。</p>
      <p>10.2 您也可以通过服务页面意见反馈功能，向我们反馈产品服务建议。</p>
      <p>10.3 针对上述内容，我们将在收到用户投诉/反馈之日起15日内予以回复。</p>

      <h2>11、其他</h2>
      <p>
        11.1
        本服务条款自发布之日起实施，并构成您和知宠派智能科技（杭州）有限公司之间的共识。知宠派智能科技（杭州）有限公司不行使、未能及时行使或者未充分行使本服务条款或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响知宠派智能科技（杭州）有限公司在将来行使该权利。
      </p>
      <p>
        11.2
        如本服务条款中的任何条款无论因何种原因完全或部分无效或不具有执行力，本服务条款的其余条款仍应有效且具有约束力，知宠派智能科技（杭州）有限公司及用户均应尽力使该条款设定的本意得到实现。
      </p>
      <p>11.4 本服务条款中的标题仅为方便而设，不作为解释本服务条款的依据。</p>
      <p>
        11.5
        如果您对本服务条款内容有任何疑问，请直接与知宠派智能科技（杭州）有限公司联系，我们将针对您的疑问给与适当释疑。
      </p>
    </div>
  );
}
